import React from "react";
import "./App.css";
import * as classes from "./App.module.css";

import ContentSelector from "./components/ContentSelector/ContentSelector";
import Game from "./containers/Game/Game";
import ImageProcessing from "./containers/ImageProcessing/ImageProcessing";
import Navbar from "./components/UI/Navbar/Navbar";
import Footer from "./components/UI/Footer/Footer";

function App() {
  const [display, setDisplay] = React.useState("webcam"); // webcam or game

  return (
    <div>
      <Navbar />
      <div className={classes.Container}>
        <ContentSelector display={display} setDisplay={setDisplay} />
        {display === "webcam" ? <ImageProcessing /> : <Game />}
      </div>
      <Footer />
    </div>
  );
}

export default App;
